import { C } from "@angular/core/src/render3";
import { MensagemErroModel } from "../../../shared/model/mensagem-erro.model";
import { Municipio } from "../../../consulta/saldo-devedor-municipio/shared/model/saldoDevedorMunicipio.model";

export class DadosOnInitModelView{
  ListaMuncicipiosAptosRoyalty:MunicipiosAptos[];
 ListaMuncicipiosRoyalty:Municipio[];
  objetoMensagem: MensagemErroModel;
}

export class CadastraMunicipiosAptosFiltro{
  MesAno:string;
}

export class MunicipiosAptos{
  SequencialMunicipioAptoRecebimentoRoyalty:number;
  SiglaUnidadeFederacao:string;
  CodigoMunicipio:number;
  NomeMunicipio:string;
  DataInicioVigencia:Date;
  DataFimVigencia:Date;
  DescricaoObservacao:string;
  CodigoServidorInclusaoRegistro: string;
  CodigoServidorExternoInclusaoRegistro: string;
  NumeroCpfBaseTerceiroInclusaoRegistro: string;
  DigitoCpfBaseTerceiroInclusaoRegistro: number;
  CodigoServidorAlteracaoRegistro: string;
  CodigoServidorExternoAlteracaoRegistro: string;
  NumeroCpfBaseTerceiroAlteracaoRegistro: string;
  DigitoCpfBaseTerceiroAlteracaoRegistro: number;
  DataInclusaoRegistro: string;
  DataInclusaoFormatada:String;
  DataAtualizacao: Date;
  DataAlteracaoFormatada:String;
}

export class CadastraMuncicipiosAptos{
  SiglaUnidadeFederacao:string;
  CodigoMunicipio:number;
  DataInicioVigencia:Date;
  DataFimVigencia:Date;
  DescricaoObservacao:string;
  LoginUsuario: string;
}

export class AlterarMuncicipiosAptos{
  SequencialMunicipioAptoRecebimentoRoyalty:number;
  SiglaUnidadeFederacao:string;
  CodigoMunicipio:number;
  DataInicioVigencia:Date;
  DataFimVigencia:Date;
  DescricaoObservacao:string;
  LoginUsuario: string;
}

export class CadastraValorMensalDistribuicaoModelView{
  ListaCadastraValorMensal : MunicipiosAptos[];
  objetoMensagem: MensagemErroModel;
}



// WEBPACK FOOTER //
// ./src/app/royalts/shared/model/municipios-aptos.model.ts